module.exports = __webpack_public_path__ + "static/media/ico-hands.a84e0a7a.svg";